import { render, staticRenderFns } from "./DelegateCard.vue?vue&type=template&id=507d0417&"
import script from "./DelegateCard.vue?vue&type=script&lang=js&"
export * from "./DelegateCard.vue?vue&type=script&lang=js&"
import style0 from "./DelegateCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports